import { render, staticRenderFns } from "./list.vue?vue&type=template&id=e196dec6&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=e196dec6&prod&scoped=true&lang=css"
import style1 from "./list.vue?vue&type=style&index=1&id=e196dec6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e196dec6",
  null
  
)

export default component.exports